'use strict';

const stockMissingStockWarning = {
    createDialog: function () {
        if (!$('#storeMissingStockWarning').length) {
            return;
        }
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.MODAL_STORE_NOINVENTORY_HEADING
            },
            paragraphs: [
                {
                    text: window.Resources.MODAL_STORE_NOINVENTORY_MESSAGE
                }
            ],
            ctaHolder: {},
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.MODAL_STORE_NOINVENTORY_BUTTON_OK,
                    shouldCloseModal: true
                }
            ],
            closeElement: {
                shouldCloseModal: true
            },
            modalLarge: true,
            centerOnMobile: true
        });
    }
};

module.exports = stockMissingStockWarning;
